<style lang="scss">
.primary-overlay {
    visibility: hidden;
    position: fixed;
    width: 100vw;
    height: 100vh;
    z-index: 100;
    top: 0;
    left: 0;
    opacity: 0;
    transition: opacity 0.2s, visibility 0s 0.2s;
    background-color: #00b519;

    &.active {
        visibility: visible;
        opacity: 1;
        transition: opacity 0.2s;
    }
}

.navigation-overlay {
    .hamburger-button {
        span {
            @apply bg-white;
        }
    }
}

/**
 * Disable body scrolling when overlayer is visible
 */

body.noscroll {
    overflow: hidden;
    width: 100vw;
    height: calc(100vh - 64px);
    height: calc(var(--vh, 1vh) * 100 - 64px); //vh fix from app.js
}
</style>

<template>
    <div class="navigation-overlay">
        <div class="primary-overlay" :class="{ active: $root.navigationIsVisble }">
            <slot></slot>
        </div>
    </div>
</template>

<script>
export default {};
</script>
